import { useTranslation } from 'react-i18next'
import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { ManualHoursReportStatuses } from '@/types'

type ManualHoursReportStatusSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
}

export const ManualHoursReportStatusSelect = ({
  value,
  onChange,
}: ManualHoursReportStatusSelectProps): JSX.Element => {
  const { t } = useTranslation('forms')

  const options = Object.keys(ManualHoursReportStatuses).map((key) => {
    const status = ManualHoursReportStatuses[
      key as keyof typeof ManualHoursReportStatuses
    ] as string

    return {
      label: t(`manualHoursReportStatus.${status}`),
      value: status,
    } as SearchAutocompleteOption
  })

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={options}
      placeholder={t('placeholders.manualHoursReportStatus')}
      sort={false}
      fieldSx={{ width: 220 }}
    />
  )
}
